export interface IFilterTipoEquipo {
  search: string;
  equipoAuxiliar?:boolean
}
export interface IFilterTableTipoEquipo {
  skip: number;
  take: number;
  search?: string | undefined;
}
export const InitialFilterTableTipoEquipo = {
  skip: 0,
  take: 30,
  search: "",
};
export interface IDataTableTipoEquipo {
  TipoEquipoId: string;
  Nombre: string;
  FechaCreada: string;
}


export interface IPostCrearTipoEquipo {
  nombre: string
}
export interface IActualizarTipoEquipo {
  TipoEquipoId: string;
  Nombre: string;
}


export interface IDataTipoEquipo{
  index:number,tipoEquipoId:string,nombre:string,codigo:string
}
export interface ITipoEquipoEdit{
  tipoEquipoId:string,nombre?:string,codigo?:string
}
export interface ITipoEquipoBody{
  nombre:string,codigo:string
}